import styled from 'styled-components';
import { FontSize, FontWeight, LineHeight } from 'web-common/src/shared/styles';

export const NumItems = styled.p`
  font-size: ${FontSize.XS};
  font-weight: ${FontWeight.BOLD};
  line-height: ${LineHeight.XXS};
  margin: 0;
`;
